var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlertContainer, AlertMessage, AlertTitle, CloseIcon, CloseIconContainer, ContentContainer, IconContainer, IconSizeContainer, MessageLinkContainer, StyledLink } from './subcomponents';
import { FA_TIMES } from '../../../const/iconProps';
import severityOptions from './helpers';
const AlertBanner = (_a) => {
    var { alertMessage, alertTitle, alertSeverity, alertLink, alertLinkText, showCloseButton } = _a, props = __rest(_a, ["alertMessage", "alertTitle", "alertSeverity", "alertLink", "alertLinkText", "showCloseButton"]);
    const [closeState, setCloseState] = useState(false);
    const location = useLocation();
    const { icon } = severityOptions[alertSeverity];
    const ariaLabel = 'ariaLabel' in props ? props.ariaLabel : undefined;
    const handleAlertClose = () => {
        setCloseState(true);
    };
    /**
     * useEffect here is meant to reset the closeState of the banner.
     * If a user closes the alert banner on the pre-login page but there's a
     * different banner to be displayed on the post-login page, the alert
     * banner will show after the user logs in.
     */
    useEffect(() => {
        setCloseState(false);
    }, [location.pathname]);
    return (!closeState && (_jsx(AlertContainer, Object.assign({ severity: alertSeverity }, { children: _jsxs(ContentContainer, { children: [_jsx(IconContainer, Object.assign({ severity: alertSeverity }, { children: _jsx(IconSizeContainer, { children: _jsx(FontAwesomeIcon, { icon: icon }) }) })), _jsxs(MessageLinkContainer, { children: [_jsxs(AlertTitle, Object.assign({ severity: alertSeverity }, { children: [alertTitle, ": "] })), _jsx(AlertMessage, { children: alertMessage }), alertLink && alertLinkText && (_jsx(StyledLink, Object.assign({ href: alertLink }, { children: alertLinkText })))] }), showCloseButton && (_jsx(CloseIconContainer, { children: _jsx(CloseIcon, Object.assign({ buttonType: "text", type: "button", id: "alert-banner-close-button", ariaLabel: ariaLabel, onClick: handleAlertClose }, { children: _jsx(FontAwesomeIcon, { icon: FA_TIMES }) })) }))] }) }))));
};
export default AlertBanner;
//# sourceMappingURL=AlertBanner.js.map